export const colorPalette = {
  white: '#ffffff',
  black: '#000000',
  // Each ramp's base step is both DEFAULT and its number, as Figma's `500-base`
  // names it. A step left out of a ramp Tailwind also ships compiles to
  // Tailwind's own colour (`gray-500` → #6b7280), not ours.
  gray: {
    DEFAULT: '#bfbfbf',
    50: '#f7f7f7',
    100: '#f2f2f2',
    200: '#e5e5e5',
    300: '#d9d9d9',
    400: '#cccccc',
    500: '#bfbfbf',
    600: '#999999',
    700: '#737373',
    800: '#57534e',
    900: '#262626',
  },
  red: {
    DEFAULT: '#f87171',
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    950: '#450a0a',
  },
  orange: {
    DEFAULT: '#fb923c',
    50: '#fff7ed',
    100: '#ffedd5',
    200: '#fed7aa',
    300: '#fdba74',
    400: '#fb923c',
    500: '#f97316',
    600: '#ea580c',
    700: '#c2410c',
    800: '#9a3412',
    900: '#7c2d12',
    950: '#431407',
  },
  green: {
    DEFAULT: '#186346',
    50: '#f0f5f3',
    100: '#d1e0da',
    200: '#a3c1b5',
    300: '#74a190',
    400: '#46826b',
    500: '#186346',
    600: '#134f38',
    700: '#0e3b2a',
    800: '#0a281c',
    900: '#05140e',
  },
  primary: {
    DEFAULT: '#282625',
    100: '#d4d4d3',
    200: '#a9a8a8',
    300: '#7e7d7c',
    400: '#535151',
    500: '#282625',
    600: '#201e1e',
    700: '#181716',
    800: '#100f0f',
    900: '#080807',
  },
  blue: {
    DEFAULT: '#0ea5e9',
    50: '#f0f9ff',
    100: '#e0f2fe',
    200: '#bae6fd',
    300: '#7dd3fc',
    400: '#38bdf8',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1',
    800: '#075985',
    900: '#0c4a6e',
    950: '#082f49',
  },

  // Figma `Theme/Base colors` and `Theme/Utility colors`. Every one of these
  // aliases a step on a ramp above; the hex is repeated here only because
  // Tailwind reads a flat object. `Theme/Action colors` is deliberately absent:
  // use the ramp steps it points at (`green`, `red`, `white`).
  background: '#fcfcfc',
  foreground: '#282625',
  card: '#ffffff',
  'card-foreground': '#282625',
  border: '#e5e5e5',
  input: '#e5e5e5',
  ring: '#282625',
  muted: '#f2f2f2',
  'muted-foreground': '#737373',

  // The colours Figma's specialty icons are drawn in. `base` is the green;
  // `accent` and `surface` are illustration colours, off the ramps on purpose.
  speciality: {
    base: '#186346',
    accent: '#31c98e',
    surface: '#e2f7ef',
  },

  brand_dark_gray: '#3E3D3C',
  header_navigation_hover: '#80808040',
  header_navigation_active: '#80808080',
  rating_good: '#7CA87C',
  main_content_bg: '#f7f6f2',
} as const;

export * from './with-alpha';
